package devxertech.com.pages.services.aiDevelopmentService

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonAboutSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.services.aiDevelopmentService.aiDevelopmentProcess.AiDevelopmentProcess
import devxertech.com.pages.services.aiDevelopmentService.aiDevelopmentTool.AiDevelopmentTool
import devxertech.com.pages.services.aiDevelopmentService.developmentServices.AiServices
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/ai-services")
@Composable
fun AiDevelopmentServices(){
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
//
        CommonHeader(
            image = Res.Image.ai_Development_header,
            breakpoint = breakpoint,
            headingText = "AI Development Services",
            descriptionText = "Our AI solutions are here to drive innovation, efficiency, and success in your business endeavors."
        )
//
        CommonArrow("Al Development")
//
//        AiDevelopmentAbout(breakpoint, sitePalette)
        CommonAboutSection(
            breakpoint =   breakpoint,
            title = "What’s Makes",
            firstFont = "Devxer an",
            secondFont = "Emerging Tech In AI Services",
            description = "We are perfect at blending concepts-We love to hear our clients’ " +
                    "ideas and blend it effectively and creatively with our team’s " +
                    "skillful design suggestions and outputs.We conduct in-depth research-" +
                    " Any project will lack authenticity and risk management guards " +
                    "if there is no prior research supporting it & our expert team at " +
                    "DEvxer loves to delve in detailed research before producing final results. " +
                    "Top Notch Deliverables- Our final product is a pillar of industry-led" +
                    " trends and practices while showcasing a complete essence" +
                    " of the product’s message and design.",
            imageName = Res.Image.ai_Development_about
        )
//
        AiServices(breakpoint, sitePalette)
//
        AiDevelopmentProcess(breakpoint, sitePalette)
//
        MakeYourOwnTeam(breakpoint)
//
        AiDevelopmentTool(breakpoint, sitePalette, text = "AI DEVELOPMENT")
//
        RatingSection(breakpoint)
//
        HomepageFooter(breakpoint)
    }
}